import { ROOFSNAP_API_BASE_URL } from '../lib/apiClients/roofSnapApiClient/roofSnapApiClient';
import {
    HIDE_SKETCH,
    SHOW_SKETCH
} from '../actions/actionTypes';

const initialState = {
    show: false,
};

const sketchHostReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_SKETCH:
            return Object.assign({}, state, {
                show: true,
                orderId: action.orderId,
                projectId: action.projectId,
            });
        case HIDE_SKETCH:
            return Object.assign({}, initialState);
        default:
            return state;
    }

};
export default sketchHostReducer;
